import axios from 'axios'
import * as restfulService from './restfulService'
import bus from '@utils/bus'

export default {
  get (domains) {
    const promises = []
    const responses = {}

    if (domains !== undefined && domains.length > 0) {
      bus.$emit('show-loader')
      domains.forEach(function (val) {
        if (val !== undefined) {
          val.route = val.route || null
          let defaultData = {
            orderBy: [
              {
                column: 'name',
                direction: 'ASC'
              }
            ]
          }
          let data = val.data || defaultData
          switch (val.domain) {

            case 'user':
              data = {}
              promises.push(restfulService.search('user', val.route, data, null, null, 1, 2000))
              responses.users = []
              break

            case 'role':
              promises.push(restfulService.search('role', val.route, data, null, null, 1, 2000))
              responses.roles = []
              break

            case 'signature':
              promises.push(restfulService.search('signature', val.route, data, null, null, 1, 2000))
              responses.signature = []
              break

            case 'permission':
              promises.push(restfulService.search('permission', val.route, data, null, null, 1, 2000))
              responses.permissions = []
              break

            case 'country':
              promises.push(restfulService.search('country', val.route, data, null, null, 1, 2000))
              responses.countries = []
              break

            case 'state':
              promises.push(restfulService.search('state', val.route, data, null, null, 1, 2000))
              responses.states = []
              break

            case 'knowledge_area':
              promises.push(restfulService.search('knowledge_area', val.route, data, null, null, 1, 2000))
              responses.knowledge_areas = []
              break

            case 'city':
              data = {
                orderBy: [
                  {
                    column: 'name',
                    direction: 'ASC'
                  }
                ]
              }
              promises.push(restfulService.search('city', 'search', data, null, null, 1, 100))
              responses.cities = []
              break

            case 'modality':
              promises.push(restfulService.search('modality', val.route, data, null, null, 1, 2000))
              responses.modalities = []
              break

            case 'layout':
              promises.push(restfulService.search('layout', val.route, data, null, null, 1, 2000))
              responses.layouts = []
              break

            case 'literacy':
              promises.push(restfulService.search('literacy', val.route, data, null, null, 1, 2000))
              responses.literacies = []
              break

            case 'place':
              data = {
                orderBy: [
                  {
                    column: 'description',
                    direction: 'ASC'
                  }
                ]
              }
              promises.push(restfulService.search('place', val.route, data, null, null, 1, 2000))
              responses.places = []
              break

            case 'event':
              data = {
                orderBy: [
                  {
                    column: 'title',
                    direction: 'ASC'
                  }
                ]
              }
              promises.push(restfulService.search('event', val.route, data, null, null, 1, 2000))
              responses.events = []
              break

            case 'marital_status':
              promises.push(restfulService.get('marital_status'))
              responses.marital_status = []
              break

            case 'special_needs':
              promises.push(restfulService.get('special_needs'))
              responses.special_needs = []
              break

            case 'ethnicity':
              promises.push(restfulService.get('ethnicity'))
              responses.ethnicities = []
              break

            case 'status':
              promises.push(restfulService.get('registration_status'))
              responses.status = []
              break

            case 'paper_type':
              promises.push(restfulService.search('paper_type', val.route, data, null, null, 1, 2000))
              responses.paper_types = []
              break

            case 'evaluation_type':
              promises.push(restfulService.search('evaluation_type', val.route, data, null, null, 1, 2000))
              responses.evaluation_types = []
              break

            case 'field':
              promises.push(restfulService.search('field', val.route, data, null, null, 1, 2000))
              responses.fields = []
              break

            case 'criteria':
              promises.push(restfulService.search('criteria', val.route, data, null, null, 1, 2000))
              responses.criterias = []
              break
            case 'event_type':
              promises.push(restfulService.search('event_type', val.route, data, null, null, 1, 2000))
              responses.event_types = []
              break
          }
        }
      })
    }

    let i = 0

    const data = axios.all(promises)
      .then((result) => {
        for (let index in responses) {
          if (result[i] !== undefined) {
            if (result[i].data !== undefined) {
              responses[index] = result[i].data
            } else {
              responses[index] = result[i]
            }
          } else {
            responses[index] = []
          }
          i++
        }
        return responses
      })

    return new Promise((resolve) => {
      resolve(data)
      bus.$emit('hide-loader')
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/services/dataService.js